export default __webpack_public_path__ + "static/media/payment_icon_3.77b4cdcf.svg";